import { AuthService } from '@/app/core/auth/auth.service';
import { LayoutService } from '@/app/layout/service/layout.service';
import { Component, computed, ElementRef, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { StyleClassModule } from 'primeng/styleclass';
import { AppBreadcrumb } from './app.breadcrumb';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, StyleClassModule, AppBreadcrumb, AvatarModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './app.topbar.html'
})
/* v8 ignore start */
export class AppTopbar {
/* v8 ignore stop */
    layoutService = inject(LayoutService);
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());

    @ViewChild('menubutton') menuButton!: ElementRef;

    onMenuButtonClick() {
        this.layoutService.toggleMenu();
    }

    logout() {
        this.authService.logout();
        void this.router.navigate(['/auth/login']);
    }
}
